<template>
    <rkm-form
        v-if="form && model"
        ref="Form"
        show-legend
    >
        <rkm-area title="Identificação" type="fieldset">
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        label="Status"
                        v-model="model.statusId"
                        :options="form.status"
                        text-field="descricao"
                        value-field="id"
                        :validations="validations.status"
                        @change="handleStatus"
                    />
                </rkm-col>
                <rkm-col cols="2">
                    <rkm-form-date-picker
                        label="Data"
                        v-model="model.data"
                        @input="handleData"
                        :validations="validations.data"
                    />
                </rkm-col>
                <rkm-col cols="4">
                    <rkm-form-select
                        label="Veículo"
                        v-model="model.veiculoId"
                        :options="form.veiculos"
                        @change="handleVeiculo"
                        text-field="descricao"
                        value-field="id"
                        show-default-option
                        :validations="validations.veiculo"
                    />
                </rkm-col>
                <rkm-col v-if="parametrizacao" cols="4">
                    <rkm-form-select
                        label="Jornada"
                        v-model="model.jornadaId"
                        :options="form.jornadas"
                        text-field="descricao"
                        value-field="id"
                        show-default-option
                        :validations="parametrizacao ? validations.jornada : null"
                        @change="() => agendados = null"
                    />
                </rkm-col>
                <rkm-col v-if="!parametrizacao" cols="4">
                    <rkm-form-select
                        label="Município"
                        v-model="model.municipioId"
                        :options="form.municipios"
                        show-default-option
                        default-option-text="Todos"
                        text-field="nome"
                        value-field="id"
                        v-if="!parametrizacao"
                        @change="() => agendados = null"
                    />
                </rkm-col>
                <rkm-col v-if="!parametrizacao" cols="4">
                    <rkm-form-select
                        label="Bairro"
                        v-model="model.nomeBairro"
                        :options="model.municipioId ? form.bairros.filter(bairro => bairro.municipioId == model.municipioId) : form.bairros"
                        show-default-option
                        default-option-text="Todos"
                        text-field="nome"
                        value-field="nome"
                        v-if="!parametrizacao"
                        @change="() => agendados = null"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Agrupamento"
                        v-model="model.agrupar"
                        :options="form.agrupar"
                        text-field="descricao"
                        value-field="id"
                    />
                </rkm-col>
                <rkm-col cols="2">
                    <rkm-form-select
                        label="Ordenar"
                        v-model="model.ordenar"
                        :options="form.ordenar"
                        text-field="descricao"
                        value-field="id"
                    />
                </rkm-col>
                <rkm-col>
                    <rkm-button
                        color="primary"
                        @click="handleSearch"
                        :label="false"
                        >Buscar</rkm-button
                    >
                    <rkm-button
                        color="secondary"
                        @click="handleClear"
                        :label="false"
                        >Limpar</rkm-button
                    >
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Viagem"
            type="fieldset"
            v-if="agendados"
        >
            <rkm-row>
                <rkm-col v-if="!parametrizacao" cols="2">
                    <rkm-form-time-picker
                        label="Horario de saída"
                        v-model="model.horarioSaida"
                        :disabled="model.statusId == enums.status.FINALIZADO"
                    />
                </rkm-col>
                <rkm-col cols="2">
                    <rkm-form-input
                        label="Diária"
                        v-model="model.diaria"
                        :disabled="this.model.statusId == 2"
                        prepend="R$"
                        v-money="money"
                        :validations="validations.diaria"
                    />
                </rkm-col>
                <rkm-col cols="4">
                    <rkm-form-select
                        label="Motorista"
                        v-model="model.motoristaId"
                        :options="agendados != null && agendados.length > 0 ? form.motoristas : []"
                        text-field="nome"
                        value-field="id"
                        show-default-option
                        :disabled="this.model.statusId == 2"
                        :validations="validations.motorista"
                        @change="handleMotorista"
                    />
                </rkm-col>
                <rkm-col>

                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor d-flex pa-2 float-right"
                        small
                        v-rkm-popover.hover.top="{
                            html:true,
                            content: 'Quantidade de passageiros agendados para a viagem.'
                        }"
                    />
                    <rkm-form-input
                        label="Total de passageiros"
                        v-model="totalPassageiros"
                        disabled
                        number
                    />
                </rkm-col>
                <rkm-col>
                    <rkm-form-input
                        label="Protocolo"
                        v-model="model.protocolo"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Agendados" v-if="agendados">
            <div v-for="(ordenacaoGrupo, ordenacaoIndex) in groupByOrdenacao(agendados)" :key="ordenacaoIndex">

                <rkm-area
                    :title="`${ordenacaoGrupo[0].tituloArea} - Total de pacientes: ${getTotalPaciente(ordenacaoGrupo)} - Total de passageiros: ${getTotalPassageiro(ordenacaoGrupo)}`"
                    type="fieldset"
                >
                    <div v-for="(item, index) in ordenacaoGrupo" :key="index" class="mb-3">
                        <rkm-table
                            :items="[item]"
                            :fields="fields"
                            hide-filters
                            hide-pagination
                        >
                            <template #thead-top>
                                <rkm-tr>
                                    <rkm-th colspan="2">
                                        Paciente: {{ item.nome ? item.nome : "" }}
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        Idade: {{ `${item.idade} anos` }}
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        <div  v-if="ordenacaoEscolhida === 'destino'">
                                            Ponto: {{ item.ponto ? item.ponto : "" }}
                                        </div>

                                        <div v-else>
                                            Local da consulta: {{ item.destino ? item.destino : "" }}
                                        </div>
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        <div  v-if="ordenacaoEscolhida === 'municipio'">
                                            Ponto: {{ item.ponto ? item.ponto : "" }}
                                        </div>

                                        <div v-else>
                                            Municipio: {{ item.municipio ? item.municipio : "" }}
                                        </div>
                                    </rkm-th>
                                </rkm-tr>

                                <rkm-tr>
                                    <rkm-th colspan="2">
                                        Observação do paciente: {{ item.observacao }}
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        Motorista: {{ item.motorista }}
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        Situação: {{ item.status }}
                                    </rkm-th>
                                    <rkm-th colspan="2">
                                        Total: {{ item.acompanhante + 1 }}
                                    </rkm-th>
                                </rkm-tr>

                                <rkm-tr v-if="form.exibirObservacaoTransporte">
                                    <rkm-th colspan="7">
                                        Observação do transporte: {{ item.consultaObservacao }}
                                    </rkm-th>
                                </rkm-tr>
                            </template>

                            <template v-slot:cell(telefones)="{ item }">
                                {{ formatPhoneNumbers(item.telefones) }}
                            </template>

                            <template v-slot:cell(acompanhante)="{ item }">
                                {{ item.acompanhante ? item.acompanhante : "0" }}
                            </template>

                            <template v-slot:cell(horarioSaida)="{ item }">
                                {{ item.horarioSaida ? item.horarioSaida.slice(0, -3) : '' }}
                            </template>

                            <template v-slot:cell(horarioConsulta)="{ item }">
                                {{ item.horarioConsulta ? item.horarioConsulta.slice(0, -3) : '' }}
                            </template>
                        </rkm-table>
                    </div>
                </rkm-area>
            </div>
        </rkm-area>

        <ModalPreferenciaImpressao ref="ModalPreferenciaImpressao" @orientation="updateOrientation"/>

    </rkm-form>
</template>

<script>

// Components
import ModalPreferenciaImpressao from '@/components/geral/impressao/Modal'

import { error, repository, stringCase, file } from "@/mixins";

import { mapActions } from "vuex";

import moment from "moment";

import status from "@/enums/transporte-paciente/status"

import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    mixins: [error, repository, stringCase, file],
    components:{ ModalPreferenciaImpressao },
    computed: {
        isPrintable() {
            return this.agendados
        },
        setStatus() {
            return this.status
        },
        validations() {
            return {
                status: {
                    required: true,
                },
                data: {
                    required: true,
                },
                veiculo: {
                    required: true,
                },
                jornada:{
                    required: true,
                },
                bairro: {
                    required: true,
                },
                diaria: {
                    min_value: 0,
                },
                motorista: {
                    required: true,
                }
            }
        },
        fields() {
            return [
                {
                    key: 'endereco',
                    label: 'Endereço',
                },
                {
                    key: 'bairro',
                    label: 'Bairro',
                },
                {
                    key: 'telefones',
                    label: 'Telefone(s)',
                },
                {
                    key: 'motivo',
                    label: 'Motivo',
                },
                {
                    key: 'horarioSaida',
                    label: 'Horário saída',
                },
                {
                    key: 'horarioConsulta',
                    label: 'Horário consulta',
                },
                {
                    key: 'acompanhante',
                    label: 'Acompanhante(s)',
                },
            ];
        },
        fieldsPaciente() {
            return [
                {
                    key: 'nome',
                    label: 'Paciente',
                },
                {
                    key: 'idade',
                    label: 'Idade',
                },
                {
                    key: 'cpf',
                    label: 'CPF',
                },
                {
                    key: 'rg',
                    label: 'RG',
                },
                {
                    key: 'destino',
                    label: 'Local da consulta',
                },
                {
                    key: 'ponto',
                    label: 'Ponto',
                },
                {
                    key: 'municipio',
                    label: 'Municipio',
                },
                {
                    key: 'observacao',
                    label: 'Observação do paciente',
                },
                {
                    key: 'motorista',
                    label: 'Motorista',
                },
                {
                    key: 'status',
                    label: 'Situação',
                },
                {
                    key: 'total',
                    label: 'Total',
                },
            ];
        }
    },
    data: () => ({
        model: null,
        form: null,
        parametrizacao: null,
        agendados: null,
        totalPassageiros: null,
        enums: {
            status
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
        orientation: '',
        ordenacaoEscolhida: '',
    }),
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        formatPhoneNumbers(numbers) {
            if(!numbers) return
            let formatedNumbers = []
            numbers.split(',').forEach(number => {
                if(number.length == 10) {
                    formatedNumbers.push(`(${number.slice(0,2)}) ${number.slice(2,6)}-${number.slice(6,10)}`)
                }
                if(number.length == 11) {
                    formatedNumbers.push(`(${number.slice(0,2)}) ${number.slice(2,7)}-${number.slice(7,11)}`)
                }
            })
            return formatedNumbers.join(', ')
        },
        handleStatus() {
            if(this.model.data) {
                this.$emit('setStatus', this.model.statusId)
                this.$emit('setPrintable', true)
                this.setLoading();
                this.repositories.listagem
                    .veiculos({
                        data: moment(this.model.data).format("YYYY-MM-DD"),
                        status_id: this.model.statusId
                    })
                    .then(({ data }) => {
                        this.form.veiculos = data
                        this.model.veiculoId = null
                        this.model.jornadaId = null
                        this.model.municipioId = null
                        this.model.bairroId = null
                        this.form.jornadas = []
                        this.form.municipios = []
                        this.form.bairros = []
                        this.agendados = null
                        this.$nextTick().then(() => this.$refs.Form.resetValidator())
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            }
        },
        handleData() {
            if (this.model.data) {
                this.setLoading();
                this.repositories.listagem
                    .veiculos({
                        data: moment(this.model.data).format("YYYY-MM-DD"),
                        status_id: this.model.statusId
                    })
                    .then(({ data }) => {
                        this.form.veiculos = data
                        this.model.veiculoId = null
                        this.model.jornadaId = null
                        this.model.municipioId = null
                        this.model.bairroId = null
                        this.form.jornadas = []
                        this.form.municipios = []
                        this.form.bairros = []
                        this.agendados = null

                        if(this.form.veiculos.length === 1) {
                            this.model.veiculoId = this.form.veiculos[0].id
                            this.handleVeiculo()
                        }

                        this.$nextTick().then(() => this.$refs.Form.resetValidator())
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            }
        },
        groupByOrdenacao(items) {
            const groups = items.reduce((groups, item) => {
                let ordenacao = item.destino;
                item.tituloArea = `Local da consulta: ${item.destino}`;

                if (this.ordenacaoEscolhida === "municipio") {
                    ordenacao = item.municipio;
                    item.tituloArea = `Município: ${item.municipio}`;
                }

                if (this.ordenacaoEscolhida === "ponto") {
                    ordenacao = item.ponto;
                    item.tituloArea = `Ponto: ${item.ponto}`;
                }

                if (!groups[ordenacao]) {
                    groups[ordenacao] = [];
                }

                groups[ordenacao].push(item);

                return groups;
            }, {});

            Object.values(groups).forEach(grupo => {
                grupo.sort((a, b) => {
                    const campo = this.handleSort();
                    if (a[campo] > b[campo]) return 1;
                    if (a[campo] < b[campo]) return -1;
                    return 0;
                });
            });

            return Object.keys(groups)
                .sort((a, b) => a.localeCompare(b))
                .map(key => groups[key]);
        },
    handleSort() {

        if (this.model.ordenar == 1) {

            return 'destino'
        } else if (this.model.ordenar == 2) {

            return 'endereco'
        } else if (this.model.ordenar == 3) {

            return 'horarioConsulta'
        } else if (this.model.ordenar == 4) {

            return 'horarioSaida'
        } else if (this.model.ordenar == 5) {

            return 'municipio'
        } else if (this.model.ordenar == 6) {

            return 'nome'
        } else if (this.model.ordenar == 7) {

            return 'ponto'
        }

        return 'ponto'
    },
        handleVeiculo() {
            if (this.model.veiculoId) {
                if (this.parametrizacao) {
                    this.setLoading();
                    this.repositories.listagem
                        .jornadas({
                            data: moment(this.model.data).format("YYYY-MM-DD"),
                            veiculo_id: this.model.veiculoId,
                            status_id: this.model.statusId
                        })
                        .then(({ data }) => {
                            this.form.jornadas = data
                            this.model.jornadaId = null
                            this.agendados = null

                            if(this.form.jornadas.length === 1) {
                                this.model.jornadaId = this.form.jornadas[0].id
                            }
                            this.$nextTick().then(() => this.$refs.Form.resetValidator())
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                } else {
                    this.setLoading();
                    this.repositories.listagem
                        .municipios({
                            data: moment(this.model.data).format("YYYY-MM-DD"),
                            veiculo_id: this.model.veiculoId,
                            status_id: this.model.statusId
                        })
                        .then(({ data }) => {
                            this.form.municipios = data
                            this.model.municipioId = null
                            this.agendados = null
                            this.$nextTick().then(() => this.$refs.Form.resetValidator())
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                    this.setLoading();
                    this.repositories.listagem
                        .bairros({
                            data: moment(this.model.data).format("YYYY-MM-DD"),
                            veiculo_id: this.model.veiculoId,
                            status_id: this.model.statusId
                        })
                        .then(({ data }) => {
                            this.form.bairros = data
                            this.model.nomeBairro = null
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                }
            }
        },
        handleMotorista() {
            if(this.model.motoristaId && this.parametrizacao && this.model.data && this.model.jornadaId) {
                this.setLoading()
                this.repositories.listagem.motorista({
                    condutor_id: this.model.motoristaId,
                    jornada_id: this.model.jornadaId,
                    data: moment(this.model.data).format("YYYY-MM-DD")
                })
                    .then(({data}) => {
                        if(!data.isValid) {
                            this.showAlert('Motorista já está cadastrado para outra jornada nessa mesma data.', 'Atenção')
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        defaultPrint() {
             if(this.model.statusId == this.enums.status.ABERTO) {

                this.$refs.Form.validate().then(valid => {
                if(!valid) return



                this.$refs.ModalPreferenciaImpressao.open();
                this.$refs.ModalPreferenciaImpressao.$once('completed', () => {
                    this.setLoading();

                    this.repositories.listagem
                        .store(this.prepareData())
                        .then(() => {
                            this.repositories.imprimir.listagemAgendados({
                                status_id: this.model.statusId,
                                data: moment(this.model.data).format("YYYY-MM-DD"),
                                veiculo_id: this.model.veiculoId,
                                nome_bairro: this.model.nomeBairro,
                                jornada_id: this.model.jornadaId,
                                municipio_id: this.model.municipioId,
                                agrupar: ["destino", "municipio", "ponto"][
                                    this.model.agrupar - 1
                                ],
                                ordenar: ["destino", "endereco", "horarioConsulta", "horarioSaida", "municipio", "nome", "ponto"][
                                    this.model.ordenar - 1
                                ],
                                orientation: this.orientation,
                            })
                            .then(response => {
                                this.showSaveNotification()
                                const content = new Blob([response.data], {type: response.headers['content-type']})
                                const url = URL.createObjectURL(content)
                                const link = document.createElement('a')
                                link.href = url
                                link.target = '_blank'
                                link.click()
                                link.remove()
                            })
                            .catch(this.handleError)
                            .finally()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                    })
                })
            }
            if(this.model.statusId == this.enums.status.FINALIZADO) {
                this.setLoading()
                this.repositories.imprimir.listagemAgendados({
                            status_id: this.model.statusId,
                            data: moment(this.model.data).format("YYYY-MM-DD"),
                            veiculo_id: this.model.veiculoId,
                            nome_bairro: this.model.nomeBairro,
                            jornada_id: this.model.jornadaId,
                            municipio_id: this.model.municipioId,
                            agrupar: ["destino", "municipio", "ponto"][
                                this.model.agrupar - 1
                            ],
                            ordenar: ["destino", "endereco", "horarioConsulta", "horarioSaida", "municipio", "nome", "ponto"][
                                this.model.ordenar - 1
                            ],
                            orientation: this.orientation,
                        })
                        .then(response => {
                            const content = new Blob([response.data], {type: response.headers['content-type']})
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')
                            link.href = url
                            link.target = '_blank'
                            link.click()
                            link.remove()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
            }
        },
        exportTo() {

             if(this.model.statusId == this.enums.status.ABERTO) {

                this.$refs.Form.validate().then(valid => {

                    if(!valid) return

                    this.setLoading()

                    this.repositories.listagem.store(this.prepareData())
                        .then(() => {

                            this.repositories.exportacao.relatorioListagem(this.prepareDataWithColumns())
                                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                                .catch(this.handleError)
                                .finally()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());

                })
            }

            if(this.model.statusId == this.enums.status.FINALIZADO) {

                this.setLoading()
                this.repositories.exportacao.relatorioViagem(this.prepareDataWithColumns())
                    .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        simplePrint() {
            if(this.model.statusId == this.enums.status.ABERTO) {
                this.$refs.Form.validate().then(valid => {
                    if(!valid) return
                        this.$refs.ModalPreferenciaImpressao.open();
                        this.$refs.ModalPreferenciaImpressao.$once('completed', () => {
                            this.setLoading();
                            this.repositories.listagem
                                .store(this.prepareData())
                                .then(() => {
                                    this.repositories.imprimir.listagemAgendadosSimples({
                                        status_id: this.model.statusId,
                                        data: moment(this.model.data).format("YYYY-MM-DD"),
                                        veiculo_id: this.model.veiculoId,
                                        nome_bairro: this.model.nomeBairro,
                                        jornada_id: this.model.jornadaId,
                                        municipio_id: this.model.municipioId,
                                        agrupar: ["destino", "municipio", "ponto"][
                                            this.model.agrupar - 1
                                        ],
                                        ordenar: ["destino", "endereco", "horarioConsulta", "horarioSaida", "municipio", "nome", "ponto"][
                                            this.model.ordenar - 1
                                        ],
                                        orientation: this.orientation,
                                    })
                                    .then(response => {
                                        this.showSaveNotification()
                                        const content = new Blob([response.data], {type: response.headers['content-type']})
                                        const url = URL.createObjectURL(content)
                                        const link = document.createElement('a')
                                        link.href = url
                                        link.target = '_blank'
                                        link.click()
                                        link.remove()
                                    })
                                    .catch(this.handleError)
                                    .finally()
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading());
                        })
                })
            }
            if(this.model.statusId ==  this.enums.status.FINALIZADO) {
                this.setLoading()
                this.repositories.imprimir.listagemAgendadosSimples({
                    status_id: this.model.statusId,
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    veiculo_id: this.model.veiculoId,
                    nome_bairro: this.model.nomeBairro,
                    jornada_id: this.model.jornadaId,
                    municipio_id: this.model.municipioId,
                    agrupar: ["destino", "municipio", "ponto"][
                        this.model.agrupar - 1
                    ],
                    ordenar: ["destino", "endereco", "horarioConsulta", "horarioSaida", "municipio", "nome", "ponto"][
                        this.model.ordenar - 1
                    ],
                    orientation: this.orientation,
                })
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')
                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        handleSearch() {
            this.agendados = null
            this.$refs.Form.validate().then(valid => {
                if(!valid) return
                this.setLoading();
                this.repositories.listagem
                    .search({
                        status_id: this.model.statusId,
                        data: moment(this.model.data).format("YYYY-MM-DD"),
                        veiculo_id: this.model.veiculoId,
                        nome_bairro: this.model.nomeBairro,
                        municipio_id: this.model.municipioId,
                        jornada_id: this.model.jornadaId,
                        ordenar: ["destino", "municipio", "ponto"][
                            this.model.agrupar - 1
                        ],
                    })
                    .then(({ data }) => {
                        if(data.pacientes && (this.model.statusId ==  1 || data.viagem)) {
                            this.$emit('setPrintable', false)
                            this.$emit('setStatus', this.model.statusId)
                            this.agendados = data.pacientes
                            this.items = data.pacientes
                            this.totalPassageiros = data.total
                            this.ordenacaoEscolhida = data.ordenacao
                        } else {
                            this.agendados = null
                        }
                        if(data.viagem) {
                            this.model.diaria = data.viagem.diaria
                            this.model.motoristaId = data.viagem.condutorId
                            this.model.horarioSaida = data.viagem.horarioSaida
                            this.model.protocolo = data.viagem.protocolo
                        } else {
                            if(this.model.statusId == 2) {
                                this.showAlert('Não foi encontrado nenhuma viagem finalizada para esta busca.', 'Atenção')
                            }
                            this.model.diaria = null
                            this.model.motoristaId = null
                            this.model.horarioSaida = null
                            this.model.protocolo = '-'
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            })
        },
        handleClear() {
            this.agendados = null
            this.model.data = null
            this.model.veiculoId = null
            this.model.jornadaId = null
            this.model.nomeBairro = null
            this.model.diaria = null
            this.model.horarioSaida = null
            this.model.motoristaId = null
            this.model.municipioId = null
            this.form.veiculos = []
            this.form.jornadas = []
            this.form.bairros = []
            this.form.municipios = []
            this.$emit('setPrintable', true)
            this.$emit('setStatus', this.model.statusId)
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        load() {
            this.setLoading();
            this.repositories.listagem
                .index()
                .then(({ data }) =>
                    this.setData(data.form, data.model, data.parametrizacao)
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        setData(form, model, parametrizacao) {
            if (form) {
                this.form = Object.assign(form);
            }
            if (model) {
                this.model = Object.assign(model);
            }
            if (parametrizacao) {
                this.parametrizacao = parametrizacao;
            }
        },
        save() {
            this.$refs.Form.validate().then(valid => {
                if(!valid) return
                this.setLoading();
                this.repositories.listagem
                    .store(this.prepareData())
                    .then(() => {
                        this.showSaveNotification();
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            })
        },
        prepareData() {
            return {
                status_id: this.model.statusId,
                data: moment(this.model.data).format("YYYY-MM-DD"),
                veiculo_id: this.model.veiculoId,
                jornada_id: this.model.jornadaId,
                horario_saida_temp: this.model.horarioSaida,
                diaria: this.model.diaria,
                condutor_id: this.model.motoristaId,
                bairro_id: this.model.bairroId,
                nome_bairro: this.model.nomeBairro,
                municipio_id: this.model.municipioId,
            }
        },
        updateOrientation(value) {
            this.orientation = value;
        },
        prepareDataWithColumns() {
            const data = this.prepareData()
            data.selectedCols = [
                ...this.fieldsPaciente.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                })),
                ...this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }))
            ];

            return data
        },
        getTotalPassageiro(item) {

            return item.reduce((total, registro) => total + (registro.acompanhante + 1), 0);
        },
        getTotalPaciente(item) {

            return item.reduce((total) => total + 1, 0);
        }
    },
    created() {
        this.repositories = {
            listagem: this.getConectaSusRepository(
                "transportePaciente.listagem"
            ),
            imprimir: this.getConectaSusRepository("impressao.transportePaciente"),
            exportacao: this.getConectaSusRepository('exportacao.transportePaciente'),
        };
    },
    mounted() {
        this.load();
    },
};
</script>
